import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  fetchAgentReportDateWiseData,
  fetchAgentReportTaskSopData,
  fetchAgentWiseReportData,
} from "../../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import CmnFilters from "../common/CmnFilters";
import AgentReportMobileCard from "./agentReportMobileCard";
import {
  agentDateWiseTbColumns,
  agentwiseTbColumns,
  agentSopTbColumns,
} from "./agent-utils";
import TaskSop from "../agent-task-sop/TaskSop";
import {
  currentMonthEndDate,
  currentMonthStartDate,
} from "../../common-data/Converts";
import CommonStructured from "../../common-components/CommonStructured";

const AgentReportDateWise = ({ userInfoData, pageName }) => {
  const dispatch = useDispatch();

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const isAdmin = userInfoData?.account_type === "admin";
  const isReceptionist = userInfoData?.account_type === "receptionist";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const receptionistGymObj = !isAdmin && !isManagerRole
    ? {
        label: userInfoData?.gym_name || "",
        value:
          userInfoData?.gym_id ||
          userInfoData?.user_id ||
          userInfoData?.uid ||
          "",
      }
    : "";

  const receptionistTypeObj = isReceptionist
    ? {
        label: "Receptionist",
        value: "receptionist",
      }
    : null;

  const receptionistAddedBy = isReceptionist
    ? {
        label: userInfoData?.name,
        value: userInfoData?.uid,
      }
    : null;

  const iniAllFilter = {
    selectedStartDate: currentMonthStartDate,
    selectedEndDate: currentMonthEndDate,
    selectedGym: !isAdmin && !isManagerRole ? receptionistGymObj : null,
    selAddedby: isReceptionist ? receptionistAddedBy : null,
    accountType: isReceptionist ? receptionistTypeObj : null,
    limit: pageLimit || 10,
  };

  const [allFilters, setAllFilters] = useState(iniAllFilter);

  const createPayload = () => ({
    token: userInfoData?.token,
    limit: pageLimit,
    page: isPage + 1,
    search: "",
    start_date: allFilters?.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
    gym_id: allFilters.selectedGym?.value || "",
    user_id: allFilters.selAddedby?.value || "",
    accountType: allFilters?.accountType?.value || "",
  });

  function callDatas() {
    const payload = createPayload();

    if (!pageName || pageName === "datewise-sale") {
      dispatch(fetchAgentReportDateWiseData(payload));
    } else if (!pageName || pageName === "fd-trainer-sales") {
      dispatch(fetchAgentWiseReportData(payload));
    } else if (!pageName || pageName === "task-sop") {
      dispatch(fetchAgentReportTaskSopData(payload));
    }
  }

  useEffect(() => {
    const payload = createPayload();

    dispatch(fetchAgentReportDateWiseData(payload));
    dispatch(fetchAgentWiseReportData(payload));
    dispatch(fetchAgentReportTaskSopData(payload));
  }, [dispatch, allFilters, userInfoData?.token, isPage, pageLimit]);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setIsPage(0);
  };

  return (
    <div>
      {pageName && (
        <CommonStructured
          pageHeading={
            pageName === "datewise-sale"
              ? "Daily Sales"
              : pageName === "fd-trainer-sales"
              ? "FD/Trainer Sales"
              : pageName === "task-sop"
              ? "Task SOP"
              : ""
          }
          isReload={callDatas}
        />
      )}

      <CmnFilters
        from={"lead-agent-report"}
        filters={allFilters}
        setFilters={setAllFilters}
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
      />

      <div className="agentTabWrapper">
        <Tabs>
          <TabList onClick={() => setIsPage(0)} className="agentTabListWrapper">
            {(!pageName || pageName === "datewise-sale") && (
              <Tab className="customTab">Date Wise</Tab>
            )}
            {(!pageName || pageName === "fd-trainer-sales") && (
              <Tab className="customTab">FD/Trainers</Tab>
            )}
            {(!pageName || pageName === "task-sop") && (
              <Tab className="customTab">Task SOP</Tab>
            )}
          </TabList>

          {(!pageName || pageName === "datewise-sale") && (
            <TabPanel>
              <AgentDateWise
                setIsPage={setIsPage}
                isPage={isPage}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            </TabPanel>
          )}

          {(!pageName || pageName === "fd-trainer-sales") && (
            <TabPanel>
              <AgentWise
                setIsPage={setIsPage}
                isPage={isPage}
                pageLimit={pageLimit}
                setPageLimit={setPageLimit}
              />
            </TabPanel>
          )}

          {(!pageName || pageName === "task-sop") && (
            <TabPanel>
              <TaskSop
                userInfoData={userInfoData}
                prevAllFilters={allFilters}
              />
              {/* <AgentTaskSop
              setIsPage={setIsPage}
              isPage={isPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            /> */}
            </TabPanel>
          )}
        </Tabs>
      </div>
    </div>
  );
};

export default AgentReportDateWise;

const AgentWise = ({ setIsPage, isPage, pageLimit, setPageLimit }) => {
  const { AgentWiseData, loading } = useSelector((state) => state.api);

  return (
    <div>
      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableColumns={agentwiseTbColumns}
            tableData={AgentWiseData?.data}
            tablePagination={AgentWiseData?.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <AgentReportMobileCard
            tableData={AgentWiseData?.data}
            tablePagination={AgentWiseData?.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            type="agentWise"
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            // userInfoData={userInfoData}
          />
        )}
      </div>
    </div>
  );
};

const AgentDateWise = ({ setIsPage, isPage, pageLimit, setPageLimit }) => {
  const { dateWiseAgentData, loading } = useSelector((state) => state.api);

  return (
    <div>
      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableColumns={agentDateWiseTbColumns}
            tableData={dateWiseAgentData?.data}
            tablePagination={dateWiseAgentData?.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            setPageLimit={setPageLimit}
            pageLimit={pageLimit}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <AgentReportMobileCard
            tableData={dateWiseAgentData?.data}
            tablePagination={dateWiseAgentData?.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            type="DateWise"
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </div>
  );
};

const AgentTaskSop = ({ setIsPage, isPage, pageLimit, setPageLimit }) => {
  const { AgentReportTaskSopData, loading } = useSelector((state) => state.api);

  return (
    <div>
      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableColumns={agentSopTbColumns}
            tableData={AgentReportTaskSopData?.data}
            isFirstColSticky={true}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        {loading ? (
          <ReactVortoxSpinner />
        ) : (
          <AgentReportMobileCard
            tableData={AgentReportTaskSopData?.data}
            type="agentsop"
          />
        )}
      </div>
    </div>
  );
};
